import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/Register.vue'
import DeviceAddPage from '../views/AddDevice.vue'
import ResetPwdPage from '../views/ResetPassword.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Register',
    component: RegisterView,
    meta: { title: '登录注册' }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
    meta: { title: '登录注册' }
  },
  {
    path: '/resetPwd',
    name: 'ResetPwd',
    component: ResetPwdPage,
    meta: { title: '忘记密码' }
  },
  {
    path: '/addDevice',
    name: 'AddDevice',
    component: DeviceAddPage,
    meta: { title: '添加设备' }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { title: '登录' }
  },
  {
    path: '/qrCodeScan',
    name: 'QRCodeScan',
    component: () => import('@/views/ScanPage.vue'),
    meta: { title: '二维码扫描' }
  },
  {
    path: '/deviceHome',
    name: 'DeviceHome',
    component: () => import('@/views/DeviceHome.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/deviceVoucherCenter',
    name: 'DeviceVoucherCenter',
    component: () => import('@/views/DeviceVoucherCenter.vue'),
    meta: { title: 'MIFI充值中心' }
  },
  {
    path: '/mifiConfirmOrder',
    name: 'MifiConfirmOrder',
    component: () => import('@/views/MifiConfirmOrder.vue'),
    meta: { title: 'MIFI确认订单' }
  },
  {
    path: '/mifiKF',
    name: 'MifiKF',
    component: () => import('@/views/MifiKF.vue'),
    meta: { title: '联系客服' }
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('@/views/CustomerChat.vue'),
    meta: { title: '在线客服' }
  },
  {
    path: '/complaint',
    name: 'Complaint',
    component: () => import('@/views/Complaint.vue'),
    meta: { title: '投诉' }
  },
  {
    path: '/deviceManger',
    name: 'DeviceManger',
    component: () => import('@/views/DeviceManager.vue'),
    meta: { title: 'MIFI设备管理' }
  },
  {
    path: '/bindDevice',
    name: 'BindDevice',
    component: () => import('@/views/BindDevice.vue'),
    meta: { title: '手机号码' }
  },
  {
    path: '/coupons',
    name: 'Coupons',
    component: () => import('@/views/Coupons.vue'),
    meta: { title: 'Mifi优惠券' }
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: () => import('@/views/Invoice.vue'),
    meta: { title: '发票服务' }
  },
  {
    path: '/invoiceList',
    name: 'InvoiceList',
    component: () => import('@/views/InvoiceList.vue'),
    meta: { title: '发票抬头' }
  },
  {
    path: '/invoiceHeader',
    name: 'InvoiceHeader',
    component: () => import('@/views/InvoiceHeader.vue'),
    meta: { title: '发票抬头' }
  },
  {
    path: '/mifiPackageAllowance',
    name: 'MifiPackageAllowance',
    component: () => import('@/views/mifiPackageAllowance.vue'),
    meta: { title: 'MIFI套餐用量' }
  },
  {
    path: '/mifiFlowDetails',
    name: 'MifiFlowDetails',
    component: () => import('@/views/mifiFlowDetails.vue'),
    meta: { title: 'MIFI流量详情' }
  },
  {
    path: '/mifiOrderList',
    name: 'MifiOrderList',
    component: () => import('@/views/MifiOrderList.vue'),
    meta: { title: 'MIFI订单记录' }
  },
  {
    path: '/payResult',
    name: 'PayResult',
    component: () => import('@/views/PayResult.vue'),
    meta: { title: '支付结果' }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
